import React, { useState, useEffect } from 'react';
import { Spin, Row, Modal } from 'antd';
import { useLocation, useHistory } from 'react-router-dom';
import { makeVerify } from '../../api';

const Redirect = () => {
    const [spinner, setSpinner] = useState(true);
    const location = useLocation();
    const history = useHistory();
    const query = new URLSearchParams(location.search);
    let payload = {};
    payload.expires = query.get('expires');
    payload.hash = query.get('hash');
    payload.signature = query.get('signature');
    const id = query.get('id');

    useEffect(() => {
        //if() {
        makeVerify({ id, payload })
            .then((response) => {
                Modal.success({
                    title: 'Success',
                    content: response.data.message,
                });
                history.push('/');
            })
            .catch((error) => {
                Modal.error({
                    title: 'Ops',
                    content: error?.response?.data?.message,
                });
                setSpinner(false);
                history.push('/');
            });
        //}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="contactUsContainer">
            <Row justify="center">{spinner ? <Spin tip="Loading..." size="large"></Spin> : ''}</Row>
        </div>
    );
};

export default Redirect;
